import { ChartOptions } from "chart.js";

export function chartOptions(max?: number): ChartOptions {
  return {
    maintainAspectRatio: false,
    responsive: true,
    hover: {
      mode: null
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'end',
        font: {
          weight: 'bold',
          size: 12,
          color: '#000'
        }
      }
    },
    scales: {
      xAxes: [{
        position: 'top',
        gridLines: {
          display: false,
          drawBorder: false
        },
        ticks: {
          min: 0,
          max: max || 600,
          stepSize: 200,
          display: false,
          beginAtZero: false,
        }
      }],
      yAxes: [{
        gridLines: {
          display: false
        }
      }]
    },
    tooltips: {
      enabled: false
    }
  };
};